export default "__VITE_ASSET__F2TH8YMl__"